var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    style: `width: 100%; height: ${_vm.height}px`,
    attrs: {
      "id": "map"
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }